import { createAction, handleActions } from "redux-actions";
import { SET_SELECTED_SCRAPER } from "../types";

const defaultState = { value: "BeatStars" };

export const setScraper = createAction(SET_SELECTED_SCRAPER, (scraperName) => ({
    scraperName
}));

const artistName = handleActions(
    {
        [setScraper]: (state, action) => {
            return {
                ...state,
                value: action.payload.scraperName || state.value
            };
        }
    },
    defaultState
);

export default artistName;
